export const SET_CATEGORIES = 'SET_CATEGORIES';
export const FETCH_CATEGORIES = 'FETCH_CATEGORIES';
export const SET_FETCH_CATEGORIES_ERROR = 'SET_FETCH_CATEGORIES_ERROR';